import React, { forwardRef } from "react";
import { translate } from "../../assets/js/functions";


const MenuButton = forwardRef(({ onClick, isOpen }, ref) => {
  return (
    <button
      id="menuButton"
      ref={ref}
      type="button"
      aria-label="Abrir el menú"
      aria-expanded={!isOpen}
      aria-controls="menu"
      className="hamburger"
      onClick={onClick}
    >
      <svg aria-hidden="true" focusable="false" width="29" height="29" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="m2 2 25 25M2 27 27 2" />
        </g>
      </svg>
      <svg aria-hidden="true" focusable="false" width="33" height="19" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1.5 1.5h30M1.5 9.5h30M1.5 17.5h30" />
        </g>
      </svg>
      <span className="is-block is-size-7 is-uppercase">{translate("Menú")}</span>
    </button>
  );
});

export default MenuButton;